/**
 * @fileoverview Various vector utility.
 * @license Apache-2.0
 */

/** v128 zero constant. */
export const v128_zero = new Uint8Array(16);
/** v128 all ones constant. */
export const v128_ones = new Uint8Array(16).fill(0xFF);
